// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__3_ny-","iconWrapper":"Loader_iconWrapper__drLdI"};